import * as React from 'react';
import { Layout } from '../../components/Layout';
import { ShareButtonContainer } from '../ShareButtonContainer';
import { ContentContainer } from '../../components/ContentContainer';
import { BuilderInfoContainer } from '../BuilderInfoContainer';
import { ConfigurationsContainerMobile } from '../ConfigurationsContainer';
import { FeaturesContainer } from '../FeaturesContainer';
import { DescriptionContainer } from '../DescriptionContainer';
import { GalleryContainerMobile } from '../GalleryContainer';
import { ActionButtonsContainer } from '../../components/ActionButtonsContainer';
import { HeadingContainer } from '../HeadingContainer';
import { FactoidsContainer } from '../FactoidsContainer';
import { LayoutSection } from '../../components/LayoutSection';
import { BuilderCallContainer } from '../BuilderCallContainer';
import { StickyCallbackButtonContainer } from '../StickyCallbackButtonContainer';
import { TourSectionContainer } from '../TourSectionContainer';
import { MortgageContainerMobile } from '../MortgageContainer';
import { OtherProjectsContainer } from '../OtherProjectsContainer';
import { BuilderReviewsContainer } from '../BuilderReviewsContainer';
import { AccreditationBanksContainer } from '../AccreditationBanksContainer';
import { ReliableBlockContainer } from '../ReliableBlockContainer';
import { EscrowBlockContainer } from '../EscrowBlockContainer';
import { useUxfbVisitedProjectsUpdater } from '../../hooks';

export const PageContainerMobile = () => {
  useUxfbVisitedProjectsUpdater();

  return (
    <>
      <Layout>
        <ContentContainer>
          <ActionButtonsContainer>
            <ShareButtonContainer />
          </ActionButtonsContainer>
        </ContentContainer>
        <LayoutSection>
          <GalleryContainerMobile />
        </LayoutSection>
        <ContentContainer>
          <LayoutSection>
            <HeadingContainer />
          </LayoutSection>
          <LayoutSection>
            <FactoidsContainer />
          </LayoutSection>
          <LayoutSection>
            <BuilderCallContainer />
          </LayoutSection>
        </ContentContainer>
      </Layout>
      <ContentContainer>
        <DescriptionContainer />
        <FeaturesContainer />
        <TourSectionContainer />
        <ConfigurationsContainerMobile />
      </ContentContainer>
      <ContentContainer>
        <BuilderInfoContainer />
      </ContentContainer>
      <StickyCallbackButtonContainer />
      <ContentContainer>
        <ReliableBlockContainer />
        <BuilderReviewsContainer />
        <AccreditationBanksContainer />
        <EscrowBlockContainer />
      </ContentContainer>
      <MortgageContainerMobile />
      <ContentContainer>
        <OtherProjectsContainer />
      </ContentContainer>
    </>
  );
};
